export const ROUTES = {
  HOME: "/",
  GDPR: "/gdpr",
  TERMS: "/termeni-si-conditii",
  CATALOG: "/catalog",
} as const;

export const STORAGE_KEYS = {
  cookieConsent: "EccoFarm_cookie_consent",
  lang: "lang",
} as const;
